module.exports = __webpack_public_path__ + "files/60449ee63020f7a26f19a5454ee34c47.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700.eot
 ** module id = 420
 ** module chunks = 0
 **/